module.exports = __webpack_public_path__ + "static/media/icon_chat_big.31d20857.svg";